export const dropInsFaqsData = [
  {
    question: 'What is Wag!?',
    answer:
      'Wag! is the #1 app for Pet Parents -- offering 5-star dog walking, pet sitting, veterinary care, and training services nationwide. Book convenient pet care in your neighborhood with the Wag! app. Whether you’re looking for daily walks, planning a trip, stuck at work, or just want your best friend to have some company - any day, anytime pet care is available through the app.',
  },
  {
    question: 'How do Drop-Ins work?',
    answer:
      'This service lasts 20 minutes and during that time, the Pet Caregiver will check in on your pet to replenish food or water, provide bathroom breaks, and more. Add notes to let your Pet Caregiver know what your pet needs, and follow along with real-time info about how the Drop-In is going.',
  },
  {
    question: 'What if I need a Pet Caregiver to stay longer than 20 minutes?',
    answer:
      "No problem! In the event a Pet Parent would like the Pet Caregiver to stay longer than 20 minutes, it is recommended the Pet Parent books a 30- or 60- minute walk in the app! Helpful tip: It's highly recommended that the Pet Parent leaves specific instructions for the Pet Caregiver around the type of service they'd like their dog to receive.",
  },
  {
    question: 'Who’s watching my pet?',
    answer:
      'Wag! pairs your furry family member with an experienced Pet Caregiver in your neighborhood. Your highly-rated Pet Caregiver will check in on your pet while you’re away.',
  },
  {
    question: 'How much does a Wag! drop-in cost?',
    answer:
      'On average, Pet Caregivers using Wag! charge $13-16 for a 20-minute Drop-In Visit. The estimated rate will be displayed at the bottom of the screen during booking, with a final price provided when a Pet Caregiver is selected for the service.',
  },
  {
    question: 'How do I evaluate Pet Caregivers?',
    answer:
      'Before any Pet Caregiver begins working for Wag!, he or she must first undergo a thorough vetting process which includes pet handling, safety tests, phone screening, and background checks. Many of the pet caregivers have worked as veterinary technicians or shelter volunteers. The majority have been lifelong pet owners and caretakers. 95% of Wag! services result in a perfect, 5-star review.',
  },
  {
    question: 'How do I pay for the service?',
    answer:
      'Wag! accepts all major credit cards, including VISA, MasterCard and American Express. Never pay by cash or check as this makes your booking ineligible for premium insurance and support.',
  },
];
